<!-- MODAL HEADER -->
<div style="border-radius: 5px; background-color: #fff;">
	<div class="float-end" style="padding:10px;">
		<span class="jmCloseBtn" (click)="close($event)"></span>
	</div>
	<br/>
	<!-- Bottom of the header -->
	<div class="row" style="margin-top:10px;">
		<div class="col-sm-6 col-12 text-center">
			<img [src]="img" style="min-height: 500px; padding-left: 20px; max-width: 100%; max-height: none;">
		</div>

		<div class="col-sm-6 col-12">
			<div>
				<div class="text-center" style="padding-top: 100px; padding-left: 5px; font-size:40px;">This feature is on its way!</div>
			</div>
			<div class="text-center" style="padding-top: 0px;">
				<div class="row" style="justify-content: center;">
					<div class="col-12 text-center">Love Journeys? Then you'll love what is coming next.</div>
				</div>
				<br />
				<div class="row" style="justify-content: center;">
					<div class="col-12 text-center">
						<button (click)="close($event)" class="btn btn-lg btn-primary">Got it! Take me back.</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Clouds logo -->
	<div class="col-12" style="padding-left: 0; padding-right: 0; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
		<img src="assets/images/clouds.png" style="width:100%; left:0;transform: scale(1);">
	</div>
</div>
